import { handleLogout } from 'src/pc/utils/auth'
import { message } from 'antd'
/**
 * 处理分页结果的通用方法
 * @param Params 请求参数
 * @param Result 返回结果
 * @param SuccessResult 当前结果
 */
export const ResultPagination = <SR, T extends PageResult<SR>, P extends PageQuery>(
  Result: T,
  SuccessResult: T | null,
  Params?: P,
): T => {
  if (SuccessResult && Params && Params.page > 1) {
    Object.assign(SuccessResult, { data: SuccessResult.data.concat(Result.data), total: Result.total })
    return SuccessResult
  }
  return Result
}

/**
 * 轮询抽象方法
 */
export const AbstractPolling = <M, P>(Main: (Params: P) => Promise<M>, Time?: number, Timeout?: number) => {
  return (Params: P, OnDone?: (Result: M) => void, OnTimeout?: () => void) => {
    let Timer = 0
    let IsStop = false
    let TimeoutTimer = 0
    const Polling = async () => {
      try {
        const Result = await Main(Params)
        OnDone?.(Result)
        window.clearTimeout(TimeoutTimer)
      } catch (e) {
        Timer = window.setTimeout(() => {
          !IsStop && Polling()
        }, Time || 1000)
      }
    }
    const StopPolling = () => {
      IsStop = true
      window.clearTimeout(Timer)
      window.clearTimeout(TimeoutTimer)
    }
    TimeoutTimer = window.setTimeout(() => {
      StopPolling()
      OnTimeout?.()
    }, Timeout || 2 * 60 * 1000)
    Polling()
    return StopPolling
  }
}

const checkErr = (result: any) => {
  //全局错误消息，有的地方会重复，暂时屏蔽
  // if (result?.code === '500') {
  //   message.warn(result?.message ?? '系统维护中，请稍后再试' + ' [500]')
  // }
  if (result.message === 'system exception') {
    result.message = '系统维护中，请稍后再试'
  }
}

/**
 * 请求成功类型
 * @param Result
 */
export const HttpSuccessType1 = <SR>(Result: ApiResult<SR>) => {
  if (Result.status_code === 1000) {
    return Result.data
  }
  if (Result.status_code === 10005) {
    handleLogout()
  }
  checkErr(Result)
  throw Result
}

/**
 * 请求成功类型
 * @param Result
 */
export const HttpSuccessType2 = <SR>(Result: ApiResult2<SR>) => {
  if (Result.code === '1') {
    return Result.result
  }
  if (Result.code === '401') {
    handleLogout()
  }
  checkErr(Result)
  throw Result
}

/**
 * 请求成功类型
 * @param Result
 */
export const HttpSuccessType3 = <SR>(Result: ApiResult<SR>) => {
  if (Result.status_code === 1000) {
    return Result
  }
  if (Result.status_code === 10005) {
    handleLogout()
  }
  checkErr(Result)
  throw Result
}
/**
 * 请求成功类型
 * @param Result
 */
export const HttpSuccessType4 = <SR>(Result: ApiResult4<SR>) => {
  if (Result.code === 0) {
    return Result.data
  }
  checkErr(Result)
  throw Result
}

/**
 * 请求成功类型
 * @param Result
 */
export const HttpSuccessType5 = <SR>(Result: ApiResult3<SR>) => {
  if (Result.code === '1') {
    return Result
  }
  if (Result.code === 'wechat_registered') {
    return Result
  }
  checkErr(Result)
  throw Result
}

export const API_URL = {
  BOX: process.env.API_URL,
  COMMON: process.env.COMMON_API_URL,
  ORIGIN: process.env.ORIGIN_API_URL,
  BOX_WEB: process.env.BOX_WEB_URL,
  BBS_WEB: process.env.BBS_WEB_URL,
}
